export enum AdmissionPeriodType {
  PROJECT_SUBMISSION = 'PROJECT_SUBMISSION',
  STUDENT_APPLICATION = 'STUDENT_APPLICATION',
  TASK_CHECK = 'TASK_CHECK',
  INTERVIEW = 'INTERVIEW',
  MENTOR_DECISION = 'MENTOR_DECISION',
  INTERNSHIP = 'INTERNSHIP',
}

export enum AdmissionAccessMode {
  PUBLIC = 'PUBLIC',
  PUBLIC_RESTRICTED = 'PUBLIC_RESTRICTED',
  PRIVATE = 'PRIVATE',
  PRIVATE_RESTRICTED = 'PRIVATE_RESTRICTED',
  PRIVATE_RESTRICTED_INVISIBLE = 'PRIVATE_RESTRICTED_INVISIBLE',
  ARCHIVED = 'ARCHIVED',
}
